import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfirmArchiveModal = ({
  quote,
  isOpen,
  loading,
  onConfirm,
  onReject
}) => {
  if (!isOpen) {
    return null;
  }
  const quoteTitle = getQuoteProperty(quote, 'hs_title');
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.archiveQuoteModal.title",
      options: {
        quoteTitle
      }
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.archiveQuoteModal.message"
    }),
    "data-test-id": "archive-quote-modal",
    use: "danger",
    onReject: onReject,
    size: "auto",
    onConfirm: onConfirm,
    ConfirmButton: LoadingButton,
    confirmButtonProps: {
      loading,
      use: 'danger'
    },
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.archiveQuoteModal.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.archiveQuoteModal.cancel"
    })
  });
};
export default /*#__PURE__*/memo(ConfirmArchiveModal);